export const API_EXTERNAL_ENDPOINT = 'cottage-deals/cottage/:cottage_id'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottage-deals/cottage/detail'
